
import { Operators_IsNull } from "../fable_modules/fable-library-js.5.3.0/FSharp.Core.js";

/**
 * True when an HTTP failure is the Server's maintenance response, not some other outage.
 * Status alone is not enough: a proxy 503 must not be reported as planned maintenance.
 */
export function isMaintenanceResponse(statusCode, body) {
    if ((statusCode === 503) && !Operators_IsNull(body)) {
        return body.trim() === "You-Thon is down for maintenance. Please try again later.";
    }
    else {
        return false;
    }
}

//# sourceMappingURL=MaintenanceSignal.js.map
